import React, { Component } from 'react'
import styled from 'styled-components'

import { connect } from 'react-redux'
import { chapterSearch } from '../../actions'
import { slugify } from '../../utils'

import Search from '../visuals/Search.js'

const SearchWrap = styled.div`
  margin-left: 38px;
  padding: 16px 0 0;
  width: 200px;
  height: 56px;
  box-sizing: border-box;
  float: left;
`
const SearchIcon = styled(Search)`
  position: absolute;
`
const SearchInput = styled.input`
  width: calc(100%);
  height: 24px;
  padding-bottom: 8px;
  box-sizing: border-box;
  background: none;
  border: 0px;
  border-bottom: 1px solid #4D4D4D;
  padding-left: 24px;
  color: #F1F1F1;
  font-family: 'Source Sans Pro';
  font-size: 16px;

  ::-webkit-input-placeholder
  {
    color: white;
    font-size: 16px;
  }
  :focus
  {
    outline: none;
  }
`

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) => ({
  chapterSearch: (chapter) => dispatch(chapterSearch(chapter))
})

class SearchBox extends Component {

  search = (e) => {
    const value = e.target.value
    // First slugify the search
    const slugged = slugify(value)
    // Then split into tokens
    const tokens = slugged.split('-')

    // Different search types
    // Single number in search will filter results on current page by chapters
    // We also have to call this if it's a blank string to reset chapterSearch in state.tracks
    const chapter = parseInt(tokens[0])
    if ( (tokens.length === 1 && !isNaN(chapter)) || tokens[0] === '') {
      this.props.chapterSearch(chapter)
    }
  }

  render () {
    return (
      <SearchWrap>
        <label htmlFor="searchInput"><SearchIcon height="17" width="17" /></label>
        <SearchInput value={this.props.searchValue} onChange={this.search} id="searchInput" type="text" name="search" placeholder="Search" />
      </SearchWrap>
    )
  }
}

SearchBox = connect(mapStateToProps, mapDispatchToProps)(SearchBox)

export default SearchBox



// WEBPACK FOOTER //
// ./src/components/Topbar/SearchBox.js